import { useMemo } from 'react';

import { SessionLeagueDetails } from '@/modules/league/new-components/types';

export type RegistrationStatusTypes =
  | 'registration-completed'
  | 'registration-closed'
  | 'player-registered'
  | 'no-online-registration'
  | 'registration-for-members-only'
  | 'registration-open';

export const useRegistrationStatus = (
  isRegistrationLocked: boolean,
  isRegistrationDateAfterNow: boolean,
  isRegistrationOnlyForMembers: boolean,
  session: SessionLeagueDetails,
  isUserRegistered: boolean,
  isUserLoggedIn: boolean
): RegistrationStatusTypes => {
  const isOnlineRegistrationActive = session.OnlineRegistration_Active;

  return useMemo(() => {
    if (isRegistrationLocked) {
      return 'registration-completed';
    }

    if (!isRegistrationLocked && isRegistrationDateAfterNow) {
      return 'registration-closed';
    }

    if (isUserLoggedIn) {
      if (isUserRegistered) return 'player-registered';
      if (isRegistrationOnlyForMembers) {
        if (!isOnlineRegistrationActive) {
          return 'no-online-registration';
        }
        return 'registration-for-members-only';
      } else {
        if (!isOnlineRegistrationActive) {
          return 'no-online-registration';
        }
      }
    }

    return 'registration-open';
  }, [
    isRegistrationLocked,
    isRegistrationDateAfterNow,
    isRegistrationOnlyForMembers,
    isUserLoggedIn,
    isUserRegistered,
    isOnlineRegistrationActive,
  ]);
};
